import type { IAppSummary } from '~/types/application'

import { VERSION_STATUS } from '~/types/version'

export const applicationSummaryMock: IAppSummary = {
  app_icon_url:
    'https://storage.mwmcdn.com/raw_files/4b6b7a53-fb3d-4519-b6fb-e7722c6b4c2f?Expires=1676562858&KeyName=mwm-files-storage-key&Signature=pHYtSGMgioz5Cpn9xJ3qS7O6rAM=',
  app_id: 'dbc77e0c-5e71-4d9d-99b7-8cbebb7a3726',
  app_key: 'bassbooster',
  authors: null,
  created_at: '2021-02-11T09:33:30.214072Z',
  created_at_ts: 1613036010214072000,
  created_by: 'e656d8b3-ac67-4d27-bb56-abc6ec954fef',
  device_type: 'ios',
  lokalise_id: '24545242',
  name: 'Bass Booster Volume Power Amp',
  owned: true,
  public_store_id: '927920917',
  release_date_ts: 1673262457000000000,
  semantic_version: '2.04.00',
  status: VERSION_STATUS.PRODUCTION,
  store_url: 'https://apps.apple.com/fr/app/id927920917',
  updated_at: '2022-05-13T15:18:09.347858Z',
  updated_at_ts: 1652455089347858400,
  updated_by: 'e656d8b3-ac67-4d27-bb56-abc6ec954fef',
  version_id: 'fb99f21a-e5eb-403a-a668-f3200bdd296d',
}
